<crm-single-select
  [options]="options"
  [(selectedItem)]="method"
  (selectedItemChange)="methodChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  optionValue="name"
  [isTemplateCombined]="true"
  [appendTo]="appendTo"
  [filter]="false">
  <ng-template
    #itemTemplate
    let-method="item">
    {{ method.value | paymentTaskScenarioMethodName }}
  </ng-template>
</crm-single-select>
